import { useMemo } from "react";
import useUserDateTime from "hooks/useUserDateTime";
import { useGetSigmaRules } from "security-app/hooks/useSigmaAPI";
export const sigmaRulesQuery = (coverageEntity) => {
  var _a;
  return `tags:${coverageEntity ? [coverageEntity.id, ...(_a = coverageEntity.childrenIds) != null ? _a : []].join() : "attack"}`;
};
const useThreatRelatedSigmaRules = (coverageEntity) => {
  const { userTimezone } = useUserDateTime();
  const { rules = [], loadingRules } = useGetSigmaRules(
    { page: 1, perPage: 1e5, query: sigmaRulesQuery(coverageEntity) },
    userTimezone,
    true
  );
  const notEnabledRules = useMemo(() => rules.filter(({ enabled }) => !enabled), [rules]);
  return {
    allRules: rules,
    loadingRules,
    notEnabledRules
  };
};
export default useThreatRelatedSigmaRules;
